import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import type { ReactNode } from 'react';

import { getMsalConfig } from './msalConfig';

/**
 * A single MSAL {@link PublicClientApplication} instance for the app lifetime.
 * `MsalProvider` (msal-react v2 + msal-browser v3) performs `initialize()` and
 * handles the redirect promise internally, so callers just render children.
 *
 * Created LAZILY on first {@link AuthProvider} render (not at module import) so
 * that auth-less apps importing the web-common barrel never construct MSAL or
 * touch the `VITE_ENTRA_*` env.
 */
let pca: PublicClientApplication | undefined;
function getPca(): PublicClientApplication {
  pca ??= new PublicClientApplication(getMsalConfig());
  return pca;
}

interface AuthProviderProps {
  children: ReactNode;
}

/** Wraps the app in the MSAL context so auth hooks/components work beneath it. */
export function AuthProvider({ children }: AuthProviderProps): JSX.Element {
  return <MsalProvider instance={getPca()}>{children}</MsalProvider>;
}
